import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'catalogos/tipo-de-horas-de-nomina';

/**
 * GET Tipos de hora de nómina
 * @returns {Promise<object[]>}
 */
export const getTiposHorasNominas = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
    /* eslint-disable-next-line no-unreachable */
  } catch (err) {
    onError(err);
  }
  return [];
};
